import { render } from "./activeSale.vue?vue&type=template&id=82ab3a88&scoped=true"
import script from "./activeSale.vue?vue&type=script&lang=js"
export * from "./activeSale.vue?vue&type=script&lang=js"

import "./activeSale.vue?vue&type=style&index=0&id=82ab3a88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82ab3a88"]])

export default __exports__